import PurchaseOrderList from './List';
import { PurchaseOrderCreate, PurchaseOrderEdit } from './Form';

export default {
  list: PurchaseOrderList,
  create: PurchaseOrderCreate,
  edit: PurchaseOrderEdit,
};
